var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEventTicketIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 11C16.5 12.38 17.62 13.5 19 13.5V16H3V13.5C4.38 13.5 5.5 12.38 5.5 11C5.5 9.62 4.38 8.5 3 8.5V6H19V8.5C17.62 8.5 16.5 9.62 16.5 11Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9697 6.5855C14.9697 6.9085 14.7067 7.1705 14.3837 7.1705C14.0607 7.1705 13.7987 6.9085 13.7987 6.5855C13.7987 6.2625 14.0607 6.0005 14.3837 6.0005C14.7067 6.0005 14.9697 6.2625 14.9697 6.5855Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9609 15.4232C14.9609 15.7412 14.7019 16.0002 14.3839 16.0002C14.0649 16.0002 13.8079 15.7412 13.8079 15.4232C13.8079 15.1052 14.0649 14.8462 14.3839 14.8462C14.7019 14.8462 14.9609 15.1052 14.9609 15.4232Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9609 13.2137C14.9609 13.5317 14.7019 13.7907 14.3839 13.7907C14.0649 13.7907 13.8079 13.5317 13.8079 13.2137C13.8079 12.8957 14.0649 12.6367 14.3839 12.6367C14.7019 12.6367 14.9609 12.8957 14.9609 13.2137Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9609 11.0042C14.9609 11.3222 14.7019 11.5812 14.3839 11.5812C14.0649 11.5812 13.8079 11.3222 13.8079 11.0042C13.8079 10.6862 14.0649 10.4272 14.3839 10.4272C14.7019 10.4272 14.9609 10.6862 14.9609 11.0042Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9609 8.7948C14.9609 9.1128 14.7019 9.3718 14.3839 9.3718C14.0649 9.3718 13.8079 9.1128 13.8079 8.7948C13.8079 8.4768 14.0649 8.2178 14.3839 8.2178C14.7019 8.2178 14.9609 8.4768 14.9609 8.7948Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92578 8.9595H12.7648",
    stroke: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92578 11.061H10.8628",
    stroke: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92578 13.1626H12.1588",
    stroke: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEventTicketIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/EventTicketIcon.bc48913d.svg";
export { ForwardRef as ReactComponent };